export const HELP_LAYOUT_TYPE = {
    BUBBLE: 'bubble',
    FULLSCREEN_TAKEOVER: 'fullscreenTakeover',
    HIDDEN: 'hidden',
    PANEL: 'panel',
    SIDEBAR: 'sidebar',
    TIP: 'tip',
    LINK: 'link'
} as const;
